import script from "./LicenseAccessWarningModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LicenseAccessWarningModal.vue?vue&type=script&setup=true&lang=js"

import "./LicenseAccessWarningModal.style.css?vue&type=style&index=0&id=4edcfbb8&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4edcfbb8"]])

export default __exports__